import { useCallback, useRef, useState } from 'react';

import { Piece } from '@apiContract';
import { ValidationData } from '@components/MailpieceActions/types';

type ValidationResult = ValidationData[number];

export const useValidationResults = (piecesForValidate: Piece[], onAllValidated: (results: ValidationData) => void) => {
  const [validatedIds, setValidatedIds] = useState<number[]>([]);
  const validatedIdsRef = useRef(validatedIds);
  const resultsRef = useRef<ValidationData>({});

  const isValidated = useCallback((pieceId: number) => validatedIdsRef.current.includes(pieceId), []);

  const addValidation = useCallback(
    (pieceId: number, result: ValidationResult) => {
      if (validatedIdsRef.current.includes(pieceId)) return;

      const updatedIds = [...validatedIdsRef.current, pieceId];
      validatedIdsRef.current = updatedIds;
      setValidatedIds(updatedIds);
      resultsRef.current[pieceId] = result;

      if (updatedIds.length === piecesForValidate.length) {
        onAllValidated(resultsRef.current);
      }
    },
    [piecesForValidate.length, onAllValidated],
  );

  const getResults = useCallback(() => resultsRef.current, []);

  return { validatedIds, isValidated, addValidation, getResults };
};
